import Vue from "vue";
import { DatetimePicker } from "vant";
import "vant/lib/picker/index.css";
import "vant/lib/style/base.css";
Vue.use(DatetimePicker);
